<template>
  <div class="card">
    <a-button
      type="dashed"
      size="large"
      icon="book"
      @click="showModal"
      style="margin-bottom: 20px"
    >
      {{ $t("action.ajouter") }}
    </a-button>
    <a-modal
      v-model="visibleModal"
      @cancel="handleCancel"
      :title="$t('all.enterInformationBelow')"
      :width="500"
      :height="1200"
      :footer="false"
    >
      <a-form :form="form" @submit="addProvider">
        <div class="row">
          <div class="col-md-6">
            <a-form-item :label="$t('inscription.nom')">
              <a-input
                :placeholder="$t('inscription.nom')"
                v-decorator="[
                  'fullName',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('requis.nom'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.adresse')">
              <a-input
                :placeholder="$t('etablissement.adresse')"
                v-decorator="['adress']"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <a-form-item :label="$t('etablissement.telephone')">
              <a-input
                :placeholder="$t('etablissement.telephone')"
                v-decorator="['phone']"
              />
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item :label="$t('etablissement.matriculeFiscale')">
              <a-input
                :placeholder="$t('etablissement.matriculeFiscale')"
                v-decorator="['matriculeFiscal']"
              />
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item :label="$t('comptabilite.email')">
              <a-input
                type="email"
                :placeholder="$t('comptabilite.email')"
                v-decorator="['email']"
              />
            </a-form-item>
          </div>
        </div>
        <div class="form-actions mt-0">
          <a-button
            type="primary"
            htmlType="submit"
            :loading="loadingClasse"
            :disabled="loadingClasse"
            class="mr-3"
          >
            {{ $t("action.ajouter") }}
          </a-button>
          <a-button key="back" @click="handleCancel" :disabled="loadingClasse">
            {{ $t("action.annuler") }}
          </a-button>
        </div>
      </a-form>
    </a-modal>
    <a-table
      :loading="tableLeading"
      :rowKey="'_id'"
      :columns="columns"
      :data-source="data"
      :pagination="true"
      :scroll="{ x: 'max-content' }"
      :customRow="
        (record) => {
          return {
            on: {
              click: () => {
                gotoProfile(record);
              },
            },
          };
        }
      "
    >
      <template
        v-for="col in [
          'fullName',
          'adress',
          'email',
          'phone',
          'matriculeFiscal',
        ]"
        :slot="col"
        slot-scope="text, record"
      >
        <div :key="col">
          <a-input
            v-if="record.editable"
            style="margin: -5px 0"
            :type="col == 'phone' ? 'number' : 'text'"
            :value="text"
            @change="(e) => handleChange(e.target.value, record._id, col)"
          />
          <template v-else> {{ text }} </template>
        </div>
      </template>
      <span slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a-button
              size="small"
              type="primary"
              @click="() => save(record._id)"
            >
              {{ $t("action.enregistrer") }}
            </a-button>
            <a-button size="small" type="danger">
              <a-popconfirm
                :title="$t('all.sureToCancelAlert')"
                @confirm="() => cancel(record._id)"
              >
                <a> {{ $t("action.annuler") }} </a>
              </a-popconfirm>
            </a-button>
          </span>
          <span v-else>
            <a-button
              type="primary"
              :disabled="editingKey !== ''"
              @click="() => edit(record._id)"
            >
              <a-icon type="edit" />{{ $t("action.modifier") }}
            </a-button>
          </span>
        </div>
      </span>
      <span slot="operationSupprimer" slot-scope="text, record">
        <div class="editable-row-operations">
          <span>
            <a-button :disabled="editingKey !== ''" type="danger">
              <a-popconfirm
                :title="$t('requis.supp')"
                @confirm="() => supp(record._id)"
              >
                <a>{{ $t("action.supprimer") }}</a>
              </a-popconfirm>
            </a-button>
          </span>
        </div>
      </span>
    </a-table>
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
var classesData = [];
export default {
  name: "classes",
  beforeMount() {
    this.form = this.$form.createForm(this, { name: "classForm" });
  },
  async created() {
    this.$gtag.pageview({
      page_path: this.$route.path,
      page_location: window.location.href,
      page_title: document.title + " - Fournisseur",
    });

    await apiClient
      .post("/providers/filter", {
        query: {
          status: "active",
        },
      })
      .then((res) => {
        classesData = [...res.data];
        classesData = classesData.map((elem) => {
          return {
            ...elem,
            key: elem._id,
          };
        });
        this.data = classesData;
        this.cacheData = classesData.map((item) => ({ ...item }));
        this.tableLeading = false;
      })
      .catch((e) => this.$message.error(this.$t("error.aucFournisseur")));
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("etablissement.nom"),
          dataIndex: "fullName",
          key: "fullName",
          scopedSlots: { customRender: "fullName" },
          sorter: (a, b) => a.fullName.length - b.fullName.length,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("etablissement.matriculeFiscale"),
          dataIndex: "matriculeFiscal",
          key: "matriculeFiscal",
          scopedSlots: { customRender: "matriculeFiscal" },
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("etablissement.adresse"),
          dataIndex: "adress",
          key: "adress",
          scopedSlots: { customRender: "adress" },
          sorter: (a, b) => a.adress - b.adress,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("comptabilite.email"),
          dataIndex: "email",
          key: "email",
          scopedSlots: { customRender: "email" },
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("etablissement.telephone"),
          dataIndex: "phone",
          key: "phone",
          scopedSlots: { customRender: "phone" },
          sorter: (a, b) => a.adress - b.adress,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("action.modifier"),
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          fixed: "right",
        },
        {
          title: this.$t("action.supprimer"),
          dataIndex: "operationSupprimer",
          scopedSlots: { customRender: "operationSupprimer" },
          fixed: "right",
        },
      ],
      tableLeading: true,
      visibleModal: false,
      form: this.$form.createForm(this),
      data: null,
      cacheData: null,
      loadingClasse: false,
      editingKey: "",
    };
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    addProvider(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.loadingClasse = true;

          apiClient
            .put("/providers", { data: values })
            .then((res) => {
              this.$message.success(this.$t("success.fournisseurAjout"));
              this.data.push(res.data);
              this.handleCancel();
            })
            .catch((e) =>
              this.$message.error(this.$t("error.impoAjoutFournisseur"))
            )
            .finally(() => (this.loadingClasse = false));
        }
      });
    },
    showModal() {
      this.visibleModal = true;
    },
    handleCancel() {
      this.form.resetFields();
      this.visibleModal = false;
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    save(key) {
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCache = newCacheData.filter((item) => key === item.key)[0];
      const updates = { ...target };
      delete updates.key;
      apiClient
        .patch("/providers/" + key, { data: updates })
        .then(() => {
          if (target && targetCache) {
            delete target.editable;
            this.data = newData;
            Object.assign(targetCache, target);
            this.cacheData = newCacheData;
          }
          this.editingKey = "";
          this.$message.success(this.$t("success.fournisseurMSA"));
        })
        .catch(() => {
          this.$message.error(this.$t("error.fournisseurNonMSA"));
          this.cancel(key);
        });
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = "";
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    },
    supp(key) {
      apiClient
        .patch("/providers/" + key, { data: { status: "inactive" } })
        .then(() => {
          this.$message.success(this.$t("success.fournisseurArchiv"));
          const dataSource = [...this.data];
          this.data = dataSource.filter((item) => item.key !== key);
        })
        .catch(() => this.$message.error(this.$t("error.fournisseurNonSupp")));
    },
    gotoProfile(record) {
      this.$router.push({
        path: "/fournisseur/" + record._id,
      });
    },
  },
};
</script>
<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.card >>> .ant-table-tbody tr {
  cursor: pointer !important;
}
</style>
